let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("b5QQH")).then(() => parcelRequire('8Tphm'));